.avatar {
  flex-shrink: 0;

  &.border-color-white {
    border: 1px solid var(--rc-theme-color-surface-default);
  }

  &.border-color-none {
    border-width: 0;
  }

  &.primary {
    background-color: var(--rc-theme-color-primary-subtle);
    color: var(--rc-theme-color-primary-default);
  }

  &.default {
    background-color: var(--rc-theme-color-surface-subtle);
    color: var(--rc-theme-color-text-default);
  }
}
